import amplitude from "amplitude-js";

const PUBLIC_API_KEY = "9a1dd2ff86bc639f3ee3bfc0eaf149ca";
amplitude.getInstance().init(PUBLIC_API_KEY);

export type AmplitudeEvent =
  | "viewLandingPage"
  | "viewSlide1"
  | "viewSlide2"
  | "viewSlide3"
  | "viewSlide4"
  | "viewSlide5"
  | "viewSlide6"
  | "viewSlide7"
  | "viewSlide8";

type AmplitudeEventData = {
  mobile?: boolean;
};

const logAmplitudeEvent = (e: AmplitudeEvent) =>
  amplitude.getInstance().logEvent(e);
const logAmplitudeEventWithData = (
  e: AmplitudeEvent,
  data: AmplitudeEventData
) => amplitude.getInstance().logEvent(e, data);

export { amplitude, logAmplitudeEvent, logAmplitudeEventWithData };
